import { ProcedureMapEnum } from '@core/procedure-helpers/models/procedure-map.enum';
import { ProcedureMapCompositePattern, ProcedureMapCheckedValue } from '@core/procedure-helpers/models/procedure-map-composites';
import type { Maybe } from '@/types/globals';

export const pmCompositeMatcher = (
	pattern: Maybe<ProcedureMapCompositePattern | ProcedureMapEnum | number>,
	value: Maybe<ProcedureMapCheckedValue>
) => {
	if (typeof pattern === 'number') {
		return pattern === value?.Id;
	} else {
		return pattern?.ProcedureId === value?.ProcedureId && (pattern?.TypeId === undefined || pattern?.TypeId === value?.TypeId);
	}
};
